import type { InventoryResource } from '@repo/api-gw-sdk';

import ConfirmationDialog from '@/components/dialogs/confirmationDialog';
import { useDAL } from '@/contexts/useDAL';

export function RestartAutomaticEnvironmentDetection({
  open,
  onClose,
  entities,
}: {
  open: boolean;
  onClose: () => void;
  entities: InventoryResource[];
}) {
  const dal = useDAL();

  const onSave = () => {
    void Promise.all(
      entities.map((entity) =>
        dal.inventory.environments.deleteOverride(entity.id).then(() => {
          entity.classifications = entity.classifications || {};
          entity.classifications.environmentDetails =
            entity.classifications.environmentDetails || {};
          entity.classifications.environmentDetails.isOverridden = false;
        })
      )
    ).finally(onClose);
  };

  return (
    <ConfirmationDialog
      isOpen={open}
      title='Resume auto-classification for environment'
      description='Environment will be automatically detected, and your overridden environment will be removed. This could change the applied backup policies and controls.'
      onCancel={onClose}
      onConfirm={onSave}
      buttonTitle='Resume'
      buttonIconClass='material-symbols-motion-play-outline-rounded'
      confirmSnackbarText='Environment auto-classification resumed.'
    />
  );
}
